/**
 * Integrytas Base App · MOBILE primitive
 * Stat strip (Direction C) — value/label pairs separated by 1px dividers, no
 * boxes. Sits between the page header and the toolbar/card.
 */
import { Fragment, type ReactNode } from 'react';

export interface MobileStat {
  value: ReactNode;
  label: string;
}

interface MobileStatStripProps {
  stats: MobileStat[];
}

export function MobileStatStrip({ stats }: MobileStatStripProps) {
  return (
    <div className="m-stats">
      {stats.map((s, i) => (
        <Fragment key={s.label}>
          {i > 0 && <div className="m-stat-div" aria-hidden />}
          <div className="m-stat">
            <span className="m-stat-v">{s.value}</span>
            <span className="m-stat-l">{s.label}</span>
          </div>
        </Fragment>
      ))}
    </div>
  );
}
